// @flow
import * as React from "react";
import { Grid, Header } from "semantic-ui-react";

import Styles from "./Section.module.scss";

type Props = {|
  title: string,
  children: React.Node,
  id?: string,
|};

const Section = (props: Props) => {
  const { title, children, id } = props;
  return (
    <Grid.Row id={id} data-cy={id}>
      <Grid.Column mobile={16} tablet={4} computer={3}>
        <Header as="h4" className={Styles["title"]}>
          {title}
        </Header>
      </Grid.Column>
      <Grid.Column computer={13} mobile={16}>
        {children}
      </Grid.Column>
    </Grid.Row>
  );
};

export default Section;
